/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
import baseUrl from '@/services/baseUrl'
import ability from '@/libs/acl/ability'
import { getAbilitiesForRole, normalizeStaffRole } from '@/libs/acl/staffAbilities'

let sessionCheck = null

export async function restoreStaffSession() {
  if (sessionCheck) return sessionCheck
  sessionCheck = (async () => {
    try {
      localStorage.removeItem('accessToken')
    } catch (e) { /* storage may be blocked */ }
    try {
      const res = await fetch(`${baseUrl.uc}/uc/v1/bo/session`, { credentials: 'include' })
      if (!res.ok) {
        localStorage.removeItem('userData')
        return false
      }
      const body = await res.json()
      const user = body && body.data && body.data.user
      if (!body.success || !user || !user.userId) {
        localStorage.removeItem('userData')
        return false
      }
      const rules = getAbilitiesForRole(user.role)
      user.ability = rules
      user.role = normalizeStaffRole(user.role)
      user.fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim()
      user.username = user.email || user.firstName
      localStorage.setItem('userData', JSON.stringify(user))
      ability.update(rules)
      return true
    } catch (e) {
      return Boolean(localStorage.getItem('userData'))
    }
  })()
  return sessionCheck
}

export const isUserLoggedIn = () => Boolean(localStorage.getItem('userData'))

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'manager') return '/'
  if (userRole === 'support') return { name: 'apps-users-uac' }
  if (userRole === 'client') return { name: 'access-control' }
  // return { name: 'auth-login' }
  return { name: 'admin-login' }
}
